import React from 'react';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import {LineupPlayerFinalTableRow} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-row';
import {LineupPlayerFinalTableHead} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-head';
import {LineupPlayersSketch} from 'components/organisms/lineup/components/lineup-players/sports/mlb/classic';
import LockedPlayerGameMarker from 'components/molecules/locked-player-game-marker';
import PlayerInjury from 'components/molecules/player-injury';
import Tooltip from 'components/atoms/tooltip';

class LineupPlayersComponent extends LineupPlayersSketch {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        const rows = lineup.players.map((player) => {
            const confirmed = player.confirmed ? (
                <Tooltip subject="Position Confirmed: Yes" iconClassName="fa fa-check" />
            ) : (
                <Tooltip subject="Position Confirmed: Unknown" iconClassName="fa fa-question-circle" />
            );

            return (
                <tr key={player.playerId} className={this.getRowClassName(player)}>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <LockedPlayerGameMarker player={player} />
                    </td>
                    <td>
                        <strong className={`player-name ${this.getStackClassName(player)}`}>{player.name}</strong>
                        <PlayerInjury player={player} />
                    </td>
                    <td className="td-confirm">{confirmed}</td>
                    <td>{player.order ? `#${player.order}` : ''}</td>
                    <td className="td-team">
                        <TeamLogo teamName={player.team} />
                    </td>
                    <td className="td-vs">{this.getOpponentsDelimiter(player)}</td>
                    <td className="td-team">
                        <TeamLogo teamName={player.opponent} />
                    </td>
                    <td>{player.salary}</td>
                    <td>{this.getPlayerPointsView(player)}</td>
                    <LineupPlayerFinalTableRow points={player.fantasyPoints} />
                    <td>{player.projOwn.getValue()}%</td>
                    <td className="td-exchange">{this.getExchangePlayerButton({player, lineup})}</td>
                </tr>
            );
        });

        return (
            <table className="table">
                <thead>
                    <tr>
                        <th className="td-pos">Pos</th>
                        <th />
                        <th>Name</th>
                        <th className="td-confirm">Confirmed</th>
                        <th className="narrow-th">Order</th>
                        <th className="td-team">Team</th>
                        <th className="td-vs"></th>
                        <th className="td-team">Opp</th>
                        <th className="td-salary">Salary</th>
                        <th className="td-fpts">Fpts</th>
                        <LineupPlayerFinalTableHead />
                        <th className="td-pown">pOwn%</th>
                        <th className="td-exchange" />
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games},
        lineupsData: {lineups, rawLineups},
        filterLineupsByPlayer,
    } = state;

    return {
        sportConfig,
        games,
        lineups,
        rawLineups,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
